export default {
  id: 'what-is-nyx',
  title: 'What is Nyx?',
  content: `## What is Nyx?

Nyx is TradeLab's AI trading coach. It is not a chatbot — it is a context-aware trading psychologist that knows your trade history, your behavioral patterns, and the current market.

> Nyx exists to improve your process, not to tell you what to buy. It does not give financial advice or issue buy/sell recommendations.

---

## Where to Find Nyx

**Profile → Nyx AI Coach** or the AI Coach icon in navigation.

---

## The Three Modes

Nyx operates in three distinct modes, each designed for a specific use case.

---

### Coach Mode

A conversational interface. You ask, Nyx answers — with full awareness of your trading history.

Nyx has access to:
- Your last 30 days of trades (entries, exits, P&L, stop adherence)
- Your ACT session history and scores
- Your Behavioral Profile and Discipline Score
- Your Risk Profile settings
- Your current open positions
- Current market scanner results

This means when you ask "why do I keep losing on breakout trades?", Nyx can actually look at your breakout trades and tell you what the pattern is — not a generic answer.

**Example questions:**
- *"I keep cutting winners early — what does my history show?"*
- *"My last 5 trades all hit the stop. What am I doing wrong?"*
- *"Is my discipline score improving or declining this month?"*

---

### Trader Mode

Nyx acts as a co-pilot when you are evaluating a specific stock for a trade.

Give Nyx a stock symbol and it returns a structured analysis:
- Current trend direction and key levels
- Relevant scanner signals that have fired recently
- RSI, MACD, and volume context
- A suggested trade plan: entry range, stop loss, target, invalidation condition
- A plain-English reason for the setup — or why it is not a setup right now

This is not a buy signal. It is a structured second opinion to complement your own analysis.

---

### Analysis Mode

A daily screener of all **51 Nifty50 stocks** ranked by a composite confidence score. Designed for finding the highest-conviction setups of the day in under a minute.

See the **Analysis Mode** and **Stock Explanations** topics for full detail.

---

## How Nyx Remembers Context

Within a session, Nyx maintains a conversation history stored in Redis. This means it remembers what you asked earlier in the same session and builds on it.

Across sessions, Nyx is re-briefed from your live data — trade history, scores, and profile — at the start of each conversation. It does not have a persistent memory across sessions but always starts with your current data.

---

## What Nyx Will Not Do

- Give a specific price target and call it a recommendation
- Predict future stock prices
- Advise on real money investments
- Make decisions for you

Nyx asks you questions back. It challenges your reasoning. It surfaces your patterns. The decision is always yours.`,
};
